import {
  trigger,
  state,
  style,
  animate,
  transition,
  keyframes,
} from '@angular/animations';

export const notifyAnimation = trigger('notify', [
  state('void', style({
    opacity: 0,
    bottom: '-100px'
  })),
  state('show', style({
    opacity: 1,
    bottom: '60px'
  })),
  transition('void => show, show => void', [
    animate('0.5s')
  ]),
]);
